export default "__VITE_ASSET__aa584e7e__"